// Week 7 / Day 1 — Профессии и польза / Professions and Value
// Solid Grade 6 math + RU Grade 3–4.

export const maxWeek7Day1 = {
  id: 'max-week-7-day-1',
  studentId: 'max',
  weekId: 'week-7',
  dayId: 'day-1',
  title: 'Профессии и польза / Professions and Value',
  shortTitle: 'Профессии и польза / Professions and Value',
  theme:
    'Макс сравнивает профессии по пользе, времени, ресурсам и результату. / Max compares professions by value, time, resources and result.',
  estimatedTimeLabel: 'Онлайн: 25–35 мин. Полный день: 80–100 мин. / Online: 25–35 min. Full day: 80–100 min.',
  nimnyIntro:
    'Нимни ведёт Макса через отношение 2:3:5, скорость выполнения, таблицу пользы и уравнение с ролями. / Nimny walks Max through a 2:3:5 ratio, unit rate, value table and a role equation.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: отношения, unit rate, среднее/медиана/размах, уравнения (Grade 6). / ratios, unit rate, mean/median/range, equations.',
    'Слой 2. Русский / Layer 2. Russian: безударные, части речи, исправление. / unstressed, parts of speech, correction.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: короткий текст о разных профессиях + план + 4 предложения.',
    'Слой 4. Логика и анализ данных / Layer 4. Logic and data analysis: заметность vs польза.',
    'Слой 5. Практика: описать одну профессию через 4 признака. / Practical: describe one profession by 4 markers.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 3/5.'
  ],
  vocabulary: [
    { term: 'профессия / profession', definition: 'дело, которое помогает людям / work that helps people' },
    { term: 'помощник / helper', definition: 'тот, кто поддерживает работу других / one who supports others’ work' },
    { term: 'мастер / master', definition: 'тот, кто делает или чинит / one who makes or fixes' },
    { term: 'проверяющий / checker', definition: 'тот, кто ищет ошибки и качество / one who checks quality' },
    { term: 'unit rate / скорость выполнения', definition: 'сколько задач за 1 минуту / tasks per minute' },
    { term: 'уравнение / equation', definition: 'равенство с x / equality with x' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Отношение задач 2:3:5 / Ratio 2:3:5',
      prompt: 'Команда распределила 120 задач между помощником, мастером и проверяющим в отношении 2:3:5. Сколько задач у каждого? / Divide 120 tasks in ratio 2:3:5.',
      helper: '2 + 3 + 5 = 10; 120 ÷ 10 = 12. / Sum parts; divide.',
      answer: 'Помощник 24; мастер 36; проверяющий 60. / 24 / 36 / 60.', unit: 'задач / tasks' },
    { id: 'q2', type: 'math', title: 'Производительность / Unit rate',
      prompt: 'Мастер сделал 18 карточек за 45 минут. Сколько карточек за 15 минут при том же темпе? / 18 cards in 45 min → cards in 15 min?',
      helper: '18/45 = 0.4 карточки/мин. / Cards per minute.',
      answer: '6 карточек. / 6 cards.', unit: 'карточек / cards' },
    { id: 'q3', type: 'math', title: 'Таблица пользы / Value table',
      prompt: 'Оценки профессий: врач 9, учитель 8, механик 7, пожарный 10, дизайнер 6. Найди среднее, медиану и размах. / Mean, median, range.',
      helper: 'Сортируй перед медианой. / Sort for median.',
      answer: 'Среднее 8; медиана 8; размах 4. / Mean 8; median 8; range 4.', unit: '' },
    { id: 'q4', type: 'math', title: 'Уравнение с ролями / Role equation',
      prompt: 'x карточек врача, 2x учителя, x + 6 механика; всего 66. Найди x. / x + 2x + (x + 6) = 66. Solve x.',
      helper: 'Собери подобные. / Combine like terms.',
      answer: 'x = 15 карточек. / x = 15.', unit: 'карточек / cards' },
    { id: 'q5', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'профессия / profession' },
        { id: 'w2', text: 'полезный / useful' },
        { id: 'w3', text: 'помогать / to help' },
        { id: 'w4', text: 'мастер / master' },
        { id: 'w5', text: 'внимательный / attentive' },
        { id: 'w6', text: 'проверять / to check' }
      ] },
    { id: 'q6', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «разние професси памагают людям по-разному, и все они нужны». / Rewrite without mistakes.',
      placeholder: 'Разные профессии... / Different professions...' },
    { id: 'q7', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «Разные профессии — разная помощь» на печатном листе. Запиши главную мысль, план из 3 пунктов и 4 предложения. / Read; main idea + plan + 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q8', type: 'text', title: 'Логика: заметность vs польза / Logic: visibility vs value',
      prompt: 'Если профессия «самая заметная», значит ли, что она самая полезная? Какие данные надо сравнить? Ответ 2–4 предложениями. / Which data should be compared?',
      placeholder: 'Заметность — это... / Visibility is...' },
    { id: 'q9', type: 'essay', title: 'Одна профессия через 4 признака / One profession by 4 markers',
      prompt: 'Опиши одну профессию через: 1) кому помогает; 2) сколько времени; 3) какие ресурсы; 4) как проверить качество. / One profession by 4 markers.',
      minSentences: 4, maxSentences: 8, placeholder: 'Помогает: ... / Время: ... / Ресурсы: ... / Проверка: ...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 7, День 1». / Heading.',
    'Слой 1. Математика: q1–q4. / Math tasks.',
    'Слой 2. Русский: части речи + исправление. / Russian.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: заметность vs польза. / Logic.',
    'Слой 5. Практика: одна профессия через 4 признака. / Practical.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 7, День 1 / Week 7, Day 1',
    subtitle: 'Профессии и польза / Professions and Value',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Логика и анализ данных / Logic and data analysis — 5–10 мин / min.',
          '5. Практика: одна профессия / Practical: one profession — 10–15 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: отношения, unit rate, среднее/медиана/размах, уравнения. Показывай все шаги. / Show all steps.' },
        { type: 'list', items: [
          '1) 120 задач в отношении 2:3:5. 2 + 3 + 5 = ____. 120 ÷ ____ = ____. Помощник: 2 × ____ = ____. Мастер: 3 × ____ = ____. Проверяющий: 5 × ____ = ____. / Divide by ratio.',
          '2) 18 карточек за 45 минут. Unit rate = 18 ÷ 45 = ____ карточки/мин. За 15 мин = ____ × 15 = ____. / Unit rate scaling.',
          '3) 9, 8, 7, 10, 6. Сумма = ____. Среднее = ____ ÷ 5 = ____. Сортировка: ____, ____, ____, ____, ____. Медиана = ____. Размах = ____ − ____ = ____. / Data.',
          '4) x + 2x + (x + 6) = 66. 4x + 6 = ____. 4x = ____. x = ____. Врач ____, учитель ____, механик ____. / Equation.',
          '5) Проверка / Check: 24 + 36 + 60 = ____ = 120? / Verify ratio.',
          '6) Проверка / Check: 6 × 3 = ____ = 18? / Verify rate.',
          '7) Optional / Доп.: если отношение 3:4:5 из 120, части = ____ / ____ / ____. / Extra ratio.',
          '8) Optional / Доп.: 12/60 = ____%. / Extra percent.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: части речи по вопросу; безударные проверяем ударением. / Parts of speech + unstressed.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: профессия, помощь, мастер, проверка, польза, ресурс, качество, время.',
          'Части речи / Parts of speech: профессия, полезный, помогать, мастер, внимательный, проверять — раздели.',
          'Исправь ошибки / Fix mistakes: «разние професси памагают людям по-разному, и все они нужны».',
          'Мини-диктант / Mini-dictation: «Разные профессии помогают людям по-разному, и все они нужны».',
          'Орфограмма дня / Spelling rule: безударные проверяемые гласные в корне. / Unstressed checkable vowels in root.'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «Разные профессии — разная помощь» / Text: Профессия — это не звание, а способ помогать людям. Врач лечит, учитель учит, механик чинит, пожарный спасает, дизайнер делает мир удобнее. Одна помощь заметна сразу, другая — только через время. Поэтому сравнивать профессии по «крутости» неверно; лучше сравнить по тому, кому и как они помогают. Тогда видно, что каждая профессия нужна, если её делают честно. / Profession is a way to help. Some help is visible now, some only later. Compare by whom and how, not by "coolness". Every honest profession is needed.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения о профессиях / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Логика и анализ данных / Layer 4. Logic and Data Analysis', blocks: [
        { type: 'text', text: 'Сравни две профессии: A — популярная в соцсетях; B — незаметная, но каждый день нужная. / Compare A (popular online) and B (quiet but needed daily).' },
        { type: 'list', items: [
          'Какие данные важны? Кому помогает / как часто / насколько трудно заменить. / Which data matter?',
          'Пример / Example: A — блогер, B — сантехник. Что произойдёт без A и без B за 1 неделю? / A vs B.',
          'Мой аргумент / My argument: __________________________________',
          'Вывод / Conclusion: заметность и польза — разные показатели. / Visibility ≠ value.',
          'Проверка / Check: назови 2 незаметных, но полезных профессии. / Name 2 quiet-but-useful professions.'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: одна профессия / Layer 5. Practical Knowledge: one profession', blocks: [
        { type: 'text', text: 'Опиши профессию через 4 признака. Это не оценка человека, а описание работы. / Describe the work, not the person.' },
        { type: 'list', items: [
          'Профессия / Profession: __________________________________',
          'Кому помогает / Who is helped: __________________________________',
          'Сколько времени в день / Daily time: ____ мин / min.',
          'Какие ресурсы / Resources: __________________________________',
          'Как проверить качество / How to check quality: __________________________________',
          'Условная ценность 1–10 / Value 1–10 (учебная): ____.',
          'Пример пользы / Example of value: __________________________________'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Что нового про профессии я понял / What is new about professions: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 3 нима / nims ✓',
          'Бонус за отношение и уравнение / Bonus for ratio and equation: +1 ☐',
          'Бонус за понятную карточку профессии / Bonus for a clear profession card: +1 ☐',
          'Итого / Total: ____ из / of 5 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: отношение 2:3:5 из 120 = 24/36/60; unit rate 0.4 карточки/мин → 6 за 15 мин; {6,7,8,9,10}: 8/8/4; уравнение x+2x+(x+6)=66 → x=15. Русский Grade 3–4. / Solid Grade 6 math + Grade 3–4 Russian.',
    mathGoal: 'q1: 24/36/60. q2: 6 карточек. q3: 8/8/4. q4: x=15. / Listed with steps.',
    russianGoal: 'Существительные: профессия, мастер. Глаголы: помогать, проверять. Прилагательные: полезный, внимательный. / Correct sorting.',
    readingWritingGoal: 'Главная мысль: сравнивать по «кому и как помогает», а не по «заметности». План + 4 предложения. / Main idea + plan + 4 sentences.',
    practicalGoal: 'Карточка одной профессии по 4 признакам + условная ценность 1–10. / One profession card + relative value.',
    check: [
      'Q1: 24 / 36 / 60.',
      'Q2: 6 карточек.',
      'Q3: 8 / 8 / 4.',
      'Q4: x = 15.',
      'Части речи разобраны. / Parts of speech.',
      'Главная мысль + план + 4 предложения. / Main idea + plan + 4 sentences.',
      'Логика заметность vs польза. / Visibility vs value.',
      'Карточка профессии по 4 признакам. / 4-marker profession card.'
    ],
    answerKey: [
      { taskId: 'q1', answer: '2 + 3 + 5 = 10; 120 ÷ 10 = 12; 24 / 36 / 60. / 24 / 36 / 60.' },
      { taskId: 'q2', answer: '18 ÷ 45 = 0.4 карточки/мин; 0.4 × 15 = 6. / 6 cards.' },
      { taskId: 'q3', answer: 'Сумма 40; среднее 8; сортировка 6/7/8/9/10; медиана 8; размах 4.' },
      { taskId: 'q4', answer: 'x + 2x + (x + 6) = 66; 4x + 6 = 66; 4x = 60; x = 15. Врач 15, учитель 30, механик 21.' },
      { taskId: 'q5', answer: 'Существительные: профессия, мастер. Глаголы: помогать, проверять. Прилагательные: полезный, внимательный.' },
      { taskId: 'q6', answer: 'Разные профессии помогают людям по-разному, и все они нужны.' },
      { taskId: 'q7', answer: 'Главная мысль: сравнивать по помощи, а не по заметности. План: 1) профессия — способ помочь; 2) помощь бывает быстрой и медленной; 3) сравниваем по «кому и как». 4 предложения — открытый ответ.' },
      { taskId: 'q8', answer: 'Ожидаемое: заметность и польза — разные показатели; данные — кому помогает, как часто, насколько трудно заменить. / Visibility ≠ value; compare by whom/how/replaceability.' },
      { taskId: 'q9', answer: 'Открытый ответ: одна профессия и 4 признака (кому, время, ресурсы, проверка). / Open answer.' }
    ],
    spellingCheck: 'Безударные проверяемые гласные подобраны; исправление ошибок чистое. / Unstressed vowels matched.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений. / Main idea + plan + retelling.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Какая профессия тебя удивила по пользе? / Which profession surprised you by its value?',
      'Что важнее: заметность или помощь? / Visibility vs help?',
      'Как ты сравниваешь две профессии? / How do you compare two professions?',
      'Какие 2 профессии ты бы объединил в команду? / Which two would you team up?'
    ],
    ifEasy: 'Усложни: пересчитай отношение 3:4:5 из 120. / Extend: recompute ratio 3:4:5 of 120.',
    ifDifficult: 'Оставь q1 и q3. / Keep q1 and q3.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 3, max: 5,
    label: 'Награда за завершение / Completion reward', display: '3 нима / 3 nims',
    bonuses: [
      { id: 'ratio-eq', label: 'Бонус за отношение и уравнение / Bonus for ratio and equation', amount: 1 },
      { id: 'clean-card', label: 'Бонус за понятную карточку / Bonus for a clear card', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q7', 'q9'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-6', dayId: 'day-5' },
  nextLessonId: 'max-week-7-day-2'
};

export default maxWeek7Day1;
